import {Item} from 'ui-library/attach-dropdown/ItemSearchInput';

/**
 * Many of the search inputs that we are using for BenchlingTypeValueInput follow the convention of returning
 * selections as arrays of Item objects, whereas in the typeDef system the value of e.g. a Bioentity leafType
 * is an api identifier (string) or an array of api identifiers if it is a list type. This is a simple util
 * to transform between the two representations
 *
 * @package
 */
export default function valuesToItemsArray(value: Array<string> | string | null): Array<Item> {
  if (typeof value === 'string') {
    return [{id: value}];
  }

  if (value == null) {
    return [];
  }

  return value.map((id) => ({id}));
}

export function itemsToValuesArray(items: Array<Item>): Array<string> {
  return items.map(({id}) => id).filter((id): id is string => id != null);
}
